// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__14yLo","containerItemsCenter":"Skeleton_containerItemsCenter__3zowI"};